/**
 *
 *    Main JS
 *    Version: 1.0
 *    Authur: Tamer Attia
 *    Website: http://www.valuepartners.com
 *    Mail: tamer.attia@exage.com
 *
 */

var userAgent = navigator.userAgent.toLowerCase();
jQuery.browser = {
	version: (userAgent.match(/.+(?:rv|it|ra|ie|me)[\/: ]([\d.]+)/) || [])[1],
	chrome: /chrome/.test(userAgent),
	safari: /webkit/.test(userAgent) && !/chrome/.test(userAgent),
	opera: /opera/.test(userAgent),
	msie: /msie/.test(userAgent) && !/opera/.test(userAgent),
	mozilla: /mozilla/.test(userAgent) && !/(compatible|webkit)/.test(userAgent)
};

//ANIMATION
var $animation_elements = $('.animationElement');
var $window = $(window);

function check_if_in_view() {
	var window_height = $window.height();
	var window_top_position = $window.scrollTop();
	var window_bottom_position = (window_top_position + window_height);

	$.each($animation_elements, function () {
		var $element = $(this);
		var element_height = $element.outerHeight();
		var element_top_position = $element.offset().top;
		var element_bottom_position = (element_top_position + element_height);
		var $animazione = $(this).data('animation');

		//check to see if this current container is within viewport
		if ((element_bottom_position >= window_top_position) &&
			(element_top_position <= window_bottom_position)) {
			$element.addClass('animated');
			$element.addClass($animazione);
		} else {
			$element.removeClass('animated');
			$element.removeClass($animazione);
		}
	});
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

function animationHover(element, animation) {
	element = jQuery(element);
	element.hover(
		function () {
			element.addClass('animated ' + animation);
		},
		function () {
			//wait for animation to finish before removing classes
			window.setTimeout(function () {
				element.removeClass('animated ' + animation);
			}, 2000);
		});
}

// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function (event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
			&&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 1000, function () {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					}
					;
				});
			}
		}
	});

(function () {
	var hasScrolled = function () {
		$(document).scroll(function () {
			if ($(document).scrollTop() >= 120) {
				$('body').addClass('hasScrolled');
			} else {
				$('body').removeClass('hasScrolled');
			}
		});
	};

	var clickMenuOpen = function () {
		$('.navbar-toggler').on('click', function (event) {
			$('html').toggleClass('menuOpened');
        })
    };
    var owlCarouselInit = function () {

        // Home Slide
        var owlSlides = $('#owl-home-slide');
        if ($(owlSlides).length) {
            owlSlides.owlCarousel({
                items: 1,
                loop: true,
                nav: false,
                dots: true
            })
        }

        // Home News
        var owlNews = $('#owl-home-news');
        if ($(owlNews).length) {
            owlNews.owlCarousel({
                items: 3,
                margin: 16,
                loop: false,
                nav: false,
                dots: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            })
        }
        
    };

	var filterDocuments = function(){

		$('a.ajax').on('click', function (event) {
			var termID = $(this).data('id');
			$("a.ajax").removeClass("current");
			$(this).addClass("current"); //adds class current to the category menu item being displayed so you can style it with css
			// console.log($(this));
			$("#loading-animation").show();
			var ajaxurl = document.location.origin + '/wp-admin/admin-ajax.php';
			$.ajax({
				type: 'POST',
				url: ajaxurl,
				data: {"action": "load-filter2", term: termID },
				success: function(response) {
					$("#category-post-content").html(response);
					$("#loading-animation").hide();
					return false;
				}
			});
		});
	};


	hasScrolled();
    clickMenuOpen();
    owlCarouselInit();
	filterDocuments();
}());


$(document).ready(function () {

});

$(window).on('load', function () {

});
jQuery(function ($) {

});

var $loading = $('#loadingDiv');
$(document)
	.ajaxStart(function () {
		$loading.show();
	})
	.ajaxStop(function () {
		$loading.hide();
	});

